import React from 'react';

import { Box } from 'theme-ui';

import withTheme from '../../../withTheme';

export type PropsT = {
  isVisible: boolean;
  handleClick: () => void;
  children?: React.ReactNode;
};

const Overlay = ({ isVisible, handleClick, children }: PropsT) => {
  return (
    <Box
      data-testid="overlay"
      onClick={handleClick}
      sx={{
        position: 'fixed',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',

        bg: 'grayscale.black',

        opacity: isVisible ? 'overlay' : '0',
        visibility: isVisible ? 'visible' : 'hidden',
        transition: 'all .2s',

        zIndex: 'drawer', // make this a variable if we have different types of overlay
      }}
    >
      {children}
    </Box>
  );
};

export default withTheme(Overlay);
